// --- Views

// Finance flow specific
import FinanceIntro from '@/views/shared/finance/FinanceIntro.vue';
import EmploymentDetailsForm from '@/views/shared/finance/EmploymentDetailsForm.vue';
import EmploymentContactDetailsForm from '@/views/shared/finance/EmploymentContactDetailsForm.vue';
import IncomeDetailsForm from '@/views/shared/finance/IncomeDetailsForm.vue';
import IncomeAmountForm from '@/views/shared/finance/IncomeAmountForm.vue';
import RentOrOwnForm from '@/views/shared/finance/RentOrOwnForm.vue';
import FinanceThankYou from '@/views/shared/finance/FinanceThankYou.vue';

// Also used in credit flows
import NameForm from '@/views/shared/NameForm.vue';
import AddressForm from '@/views/shared/AddressForm.vue';
import DateOfBirthForm from '@/views/shared/DateOfBirthForm.vue';
import ContactDetailsForm from '@/views/shared/ContactDetailsForm.vue';
import ErrorView from '@/views/shared/ErrorPageV2.vue';

export default [
  {
    path: '',
    redirect: { path: 'finance-intro' },
  },
  {
    path: 'finance-intro',
    component: FinanceIntro,
    meta: {
      headerIcon: 'back',
      hasNext: true,
      nextRoutePath: 'employment-details-form',
    },
  },
  {
    path: 'employment-details-form',
    component: EmploymentDetailsForm,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 0,
        to: 1,
      },
      hasNext: true,
      nextRoutePath: 'employment-contact-details-form',
      showPaymentInfo: true,
    },
  },
  {
    path: 'employment-contact-details-form',
    component: EmploymentContactDetailsForm,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 1,
        to: 2,
      },
      hasNext: true,
      nextRoutePath: 'income-details-form',
      showPaymentInfo: true,
    },
  },
  {
    path: 'income-details-form',
    component: IncomeDetailsForm,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 2,
        to: 3,
      },
      hasNext: true,
      nextRoutePath: 'income-amount-form',
      showPaymentInfo: true,
    },
  },
  {
    path: 'income-amount-form',
    component: IncomeAmountForm,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 3,
        to: 4,
      },
      hasNext: true,
      nextRoutePath: 'rent-or-own-form',
      showPaymentInfo: true,
    },
  },
  {
    path: 'rent-or-own-form',
    component: RentOrOwnForm,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 4,
        to: 5,
      },
      hasNext: true,
      showPaymentInfo: true,
    },
  },
  {
    path: 'address-form',
    component: AddressForm,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 5,
        to: 6,
      },
      hasNext: true,
      nextRoutePath: 'date-of-birth-form',
      showPaymentInfo: true,
    },
  },
  {
    path: 'date-of-birth-form',
    component: DateOfBirthForm,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 6,
        to: 7,
      },
      hasNext: true,
      nextRoutePath: 'name-form',
      showPaymentInfo: true,
    },
  },
  {
    path: 'name-form',
    component: NameForm,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 7,
        to: 8,
      },
      hasNext: true,
      nextRoutePath: 'contact-details-form',
      showPaymentInfo: true,
    },
  },
  {
    path: 'contact-details-form',
    component: ContactDetailsForm,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 8,
        to: 9,
      },
      hasNext: true,
      nextRoutePath: 'finance-thank-you',
      showPaymentInfo: true,
    },
  },
  {
    path: 'finance-thank-you',
    component: FinanceThankYou,
    meta: {
      headerIcon: false,
      completeLeadOnEnter: true, // ecom only, not B&P
    },
  },
  // Subflow general error route
  {
    path: 'error',
    component: ErrorView,
    meta: {
      headerIcon: false,
      navInfo: false,
      hasNext: true,
      errorPayload: {
        errorType: 'general',
        errorMsg: 'subFlow',
        buttonText: 'continuePayment',
      },
    },
  },
  {
    path: '*',
    redirect: { path: 'error' },
  },
];
